import React, {useEffect} from 'react';
import Button, {ButtonSizes} from '../../components/ButtonNew';
import FAQs from '../../components/FAQs';
import {useAnalytics} from '../../hooks';
import {getBrandName} from '../../components/Brand';

const postJobForm = 'https://airtable.com/app8jkwWK6HRuubko/shrFOFdAMjdopCHZj';

const steps = [
  {
    name: 'Submit form',
    description: 'Fill out our job posting form with details about the role.',
  },
  {
    name: 'Get approved',
    description: 'Our team will review your submission and reach out once it\'s approved.',
  },
  {
    name: 'Go live',
    description: 'Attract top applications from our talent community right away.',
  },
];

const PostJobFAQs = [
  {
    question: 'How long will my job posting stay live?',
    answer: "Job posts are live for the first 7 days at no cost. After that, we offer paid plans to extend your post's visibility for a longer window. Contact us to extend, update, or remove the listing.",
  },
  {
    question: 'When will my job posting be live?',
    answer: 'Submissions for job postings are typically reviewed and approved within 1-2 business days.',
  },
  {
    question: 'Is there a fee to post a job?',
    answer: 'The first week is free. After that, we have payment plans to keeping your post live for a longer window.',
  },
  {
    question: 'Where will my job be shown?',
    answer: `Your role will be posted on ${getBrandName()}'s job board page, featured in a newsletter blast to our 500k+ users, and if applicable, featured on APM List.`,
  },
  {
    question: 'Can I post more than one job?',
    answer: "Yes, you can submit as many roles as you'd like. Fill out a separate form for each position you'd like to post.",
  },
];

export default function PostJobPage() {
  const {tracker} = useAnalytics();

  useEffect(() => { tracker.postJobLandingView(); }, []);

  return (
    <div className="relative bg-white overflow-hidden">
      <div className="relative pt-6 pb-16 sm:pb-24">
        <main className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
          <div className="text-center">
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
              {`Post a job to the ${getBrandName()} Community`}
            </h1>
            <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              Get access to top talent from our community of 1M+ tech candidates.
            </p>
            <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
              <Button
                size={ButtonSizes.LARGE}
                href={postJobForm}
                target="_blank"
                onClick={() => tracker.postJobClick()}
              >
                Post a Job →
              </Button>
            </div>
          </div>
        </main>

        <div className="mt-16 mx-auto max-w-7xl px-4 pb-10 text-center">
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900">
            How does it work?
          </h2>
        </div>

        <div className="max-w-xl mx-auto lg:max-w-4xl">
          <div className="flex flex-wrap justify-between">
            {steps.map((step, num) => (
              <div className="flex flex-col items-start flex-auto pb-8 ml-4 md:flex-1" key={step.name}>
                <span className="flex items-center justify-center rounded-full border border-black w-8 h-8 bg-white text-black text-lg font-medium mb-6">{num + 1}</span>
                <p className="mb-3 text-left font-bold  text-xl">{step.name}</p>
                <p className="mt-2 text-base text-gray-500 text-left">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="max-w-6xl mx-auto px-4 md:px-6 mt-16">
          <h2 className="text-xl md:text-3xl text-center font-bold text-black">
            Why Hiring Teams Choose Us
          </h2>
          <p className="text-center text-base text-gray-500 mt-1">
            Check out what recruiters and candidates have to say.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
            {placeholderTestimonials.map((testimonial) => (
              <Testimonial testimonial={testimonial} key={testimonial.id} />
            ))}
          </div>
        </div> */}

        <div className="mt-16 mx-auto max-w-7xl px-4 text-center">
          <h2 className="text-base sm:text-lg md:text-xl font-bold text-black mb-4">
            {`Find top candidates through ${getBrandName()}`}
          </h2>
          <Button
            size={ButtonSizes.LARGE}
            href={postJobForm}
            target="_blank"
            onClick={() => tracker.postJobClick()}
          >
            Post a Job
          </Button>
        </div>

        <div className="mt-16 py-16">
          <div className="mx-auto max-w-7xl px-4 pb-8 text-center">
            <h2 className="text-3xl tracking-tight font-extrabold text-gray-900">
              FAQs
            </h2>
          </div>
          <FAQs items={PostJobFAQs} />
        </div>

        <p className="text-lg italic text-center text-gray-500 pt-5">
          For questions about job postings, email us at support@aced.io.
        </p>
      </div>
    </div>
  );
}
